// extracted by mini-css-extract-plugin
var _1 = "NavButtonTooltip-module__blurbBg--IFBI8";
var _2 = "NavButtonTooltip-module__blurbButton--K_V7m";
var _3 = "NavButtonTooltip-module__blurbContent--uvX98 CoreGeneral__robotoSlab--X8lgW fontSize__bookMenu--psDDX";
var _4 = "NavButtonTooltip-module__blurbContentV--T2yOk NavButtonTooltip-module__blurbContent--uvX98 CoreGeneral__robotoSlab--X8lgW fontSize__bookMenu--psDDX";
var _5 = "NavButtonTooltip-module__blurbQ--yRzKO";
var _6 = "NavButtonTooltip-module__infoBlurb--rVQl6";
var _7 = "NavButtonTooltip-module__introBlurb--sdh_s NavButtonTooltip-module__infoBlurb--rVQl6";
var _8 = "NavButtonTooltip-module__unlockBlurb--A7oCq NavButtonTooltip-module__infoBlurb--rVQl6";
export { _1 as "blurbBg", _2 as "blurbButton", _3 as "blurbContent", _4 as "blurbContentV", _5 as "blurbQ", _6 as "infoBlurb", _7 as "introBlurb", _8 as "unlockBlurb" }
